import { create } from "zustand";

import { THEME_OPTIONS, type ThemeId } from "@/shared/design-tokens/themes.js";
import { STORAGE_KEYS } from "@/shared/storage/keys.js";
import { readStorageItem, writeStorageItem } from "@/shared/storage/localStorage.js";

export { THEME_OPTIONS, type ThemeId };

function isThemeId(value: string | null): value is ThemeId {
  return THEME_OPTIONS.some((theme) => theme.id === value);
}

function readInitialTheme(): ThemeId {
  const stored = readStorageItem(STORAGE_KEYS.theme);
  return isThemeId(stored) ? stored : "default";
}

type ThemeState = {
  theme: ThemeId;
  setTheme: (theme: ThemeId) => void;
};

export const useThemeStore = create<ThemeState>((set) => ({
  theme: readInitialTheme(),
  setTheme(theme) {
    writeStorageItem(STORAGE_KEYS.theme, theme);
    set({ theme });
  },
}));
